<div class="row no-gutters">
    <div class="col-md-12 col-lg-6">
        <div class="row no-gutters">
            <div class="col-sm-10">

                <gender-twb [idPrefix]="(idPrefix + 'client_user.')" [(bananaBox)]="bananaBox.gender"></gender-twb>

                <div class="row no-gutters mt-1">
                    <div class="col-sm-12">
                        <mat-form-field class="full-width">
                            <mat-label>{{ bananaBox.trans.firstname | translate }}</mat-label>
                            <input id="{{idPrefix}}{{bananaBox.trans.firstname}}"
                                   type="text" matInput
                                   [(ngModel)]="bananaBox.firstname"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-sm-12">
                        <mat-form-field class="full-width">
                            <mat-label>{{ bananaBox.trans.lastname | translate }}</mat-label>
                            <input id="{{idPrefix}}{{bananaBox.trans.lastname}}"
                                   type="text" matInput
                                   [(ngModel)]="bananaBox.lastname"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-sm-12">
                        <mat-form-field class="full-width">
                            <mat-label>{{ bananaBox.trans.user_code | translate }}</mat-label>
                            <input id="{{idPrefix}}{{bananaBox.trans.user_code}}"
                                   type="text" matInput
                                   [formControl]="user_code"
                                   required>
                            <mat-error>{{ getUserCodeError() | translate }}</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <address-twb [idPrefix]="(idPrefix + 'client_user.')" [(bananaBox)]="bananaBox.address"></address-twb>

            </div>
            <div class="col-sm-2">
                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
            </div>
        </div>
    </div>

    <div class="col-md-12 col-lg-6">

        <div class="row no-gutters" style="margin-top: 41px;">
            <div class="col-sm-12">

                <contacts-twb [idPrefix]="(idPrefix + 'client_user.')" [(bananaBox)]="bananaBox.address.contacts"></contacts-twb>

            </div>
        </div>

    </div>
</div>
